import React from 'react'
import { useHistory } from 'react-router'
import { RewardPoolDetails } from 'src/config/Config'
import { CombinedAPY } from '../CombinedAPY'
import { useFarmTableRow } from './useFarmTableRow'
import { RowLoader } from '../RowLoader'

interface IProps {
  rewardPool: RewardPoolDetails
}

export function FarmTableRow(props: IProps) {
  const history = useHistory()
  const farmDetails = useFarmTableRow(props.rewardPool)

  if (!farmDetails) {
    return <RowLoader columnCount={7} />
  }

  return (
    <tr key={farmDetails.name}>
      <td>{props.rewardPool.name?.split('-')[1]}</td>
      <td>{farmDetails.pair}</td>
      <td>{farmDetails.platform}</td>
      <td>{farmDetails.totalRewards}</td>
      <td>{farmDetails.earnedAmount}</td>
      <td>
        {
          <CombinedAPY
            apys={farmDetails?.apys}
            isRewardPeriodFinished={farmDetails.isRewardPeriodFinished}
          />
        }
      </td>
      <td>
        <button
          className="farms__button"
          onClick={() => {
            history.push(`${history.location.pathname}/${farmDetails?.name}`)
          }}
        >
          View
        </button>
      </td>
    </tr>
  )
}
